import React, {useState} from 'react';
import {IoChevronUp, IoChevronDown} from 'react-icons/io5';

import {Container, Row, Order, Drag} from './styles';
import {OrderByProps} from '../../state';
import {MdDragIndicator} from 'react-icons/md';

interface Props {
  label: string;
  field: string;
  onChange: (field: string) => void;
  orderBy?: OrderByProps;
  reorderProjection: (from: string, to: string) => void;
}

const HeaderColumn: React.FC<Props> = ({
  label,
  field,
  onChange,
  orderBy,
  reorderProjection,
}) => {
  const isOrdering = orderBy?.field === field;
  const [isDragOver, setDragOver] = useState(false);

  return (
    <Container
      {...{isDragOver}}
      draggable
      onDragOver={(e) => {
        e.preventDefault();
        setDragOver(true);
      }}
      onDrop={(e) => {
        reorderProjection(e.dataTransfer.getData('field'), field);
        setDragOver(false);
      }}
      onDragLeave={() => setDragOver(false)}
      onDragStart={(e) => e.dataTransfer.setData('field', field)}>
      <Row onClick={() => onChange(field)}>
        <Drag>
          <MdDragIndicator size={16} />
        </Drag>
        {label}
        <Order visible={isOrdering}>
          <IoChevronUp
            size={8}
            color={
              isOrdering && orderBy.order === 1
                ? 'black'
                : 'rgba(128, 128, 128, 1)'
            }
          />
          <IoChevronDown
            size={8}
            color={
              isOrdering && orderBy.order === -1
                ? 'black'
                : 'rgba(128, 128, 128, 1)'
            }
          />
        </Order>
      </Row>
    </Container>
  );
};

export default HeaderColumn;
